import React from "react";
import styled from "@emotion/styled";
import { MoreVertical } from "react-feather";

import {
  Card as MuiCard,
  CardHeader,
  IconButton,
  Chip as MuiChip,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { spacing } from "@mui/system";

const Card = styled(MuiCard)(spacing);

const Chip = styled(MuiChip)`
  height: 20px;
  padding: 4px 0;
  font-size: 90%;
  background-color: ${(props) =>
    props.theme.palette[props.color ? props.color : "primary"].light};
  color: ${(props) => props.theme.palette.common.white};
`;

const Paper = styled(MuiPaper)(spacing);

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)});
`;

// Data
let id = 0;
function createData(name, start, end, state, assignee) {
  id += 1;
  return { id, name, start, end, state, assignee };
}

const rows = [
  // createData(
  //   "Project Aurora",
  //   "01/01/2023",
  //   "31/06/2023",
  //   <Chip label="Done" color="success" />,
  //   "6"
  // ),
  // createData(
  //   "Project Eagle",
  //   "01/01/2023",
  //   "31/06/2023",
  //   <Chip label="In Progress" color="warning" />,
  //   "5"
  // ),
  // createData(
  //   "Project Fireball",
  //   "01/01/2023",
  //   "31/06/2023",
  //   <Chip label="Done" color="success" />,
  //   "5"
  // ),
  // createData(
  //   "Project Omega",
  //   "01/01/2023",
  //   "31/06/2023",
  //   <Chip label="Cancelled" color="error" />,
  //   "4"
  // ),
  // createData(
  //   "Project Yoda",
  //   "01/01/2023",
  //   "31/06/2023",
  //   <Chip label="Done" color="success" />,
  //   "2"
  // ),
  // createData(
  //   "Project Zulu",
  //   "01/01/2023",
  //   "31/06/2023",
  //   <Chip label="Done" color="success" />,
  //   "1"
  // ),
];

const Table1 = () => (
  <Card mb={6} style={{ height: "100%" }}>
    <CardHeader
      action={
        <IconButton aria-label="settings" size="large">
          <MoreVertical />
        </IconButton>
      }
      title="Agents"
    />
    <Paper>
      <TableWrapper>
        <Table>
          {/* <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Count</TableCell>
            </TableRow>
          </TableHead> */}
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="right">{row.assignee}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableWrapper>
    </Paper>
  </Card>
);

export default Table1;
